import { Badge, Eyebrow, StrongText, Subheading, SurfaceCard, SurfaceRow } from '../../../components/ui'
import { GENETIC_PROFILE, GENETIC_RISKS, PHARMACOGENOMICS } from '../constants'
import { uiClasses } from '../../shared/uiClasses'
import { GradientSphereMetricCard, sphereColorAt } from '../components/GradientSphereCard'

const TEXT_SECONDARY = uiClasses.textSecondary
const TEXT_SUBTLE = uiClasses.textSubtle

export default function GeneticsTab() {
  const elevatedRisks = GENETIC_RISKS.filter((risk) => risk.risk === 'elevated').length
  const moderateRisks = GENETIC_RISKS.filter((risk) => risk.risk === 'moderate').length
  const actionableRisks = GENETIC_RISKS.filter((risk) => risk.actionable).length

  return (
    <div className="space-y-6">
      <SurfaceCard as="article" className="genetics-header-shell">
        <div className="genetics-header-layout">
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <Subheading variant="dashboard">Genomics overview</Subheading>
              <Badge variant="zinc">
                {GENETIC_RISKS.length} risk signals
              </Badge>
            </div>

            <div className="genetics-inline-metrics mt-5">
              <GradientSphereMetricCard
                label="Variants analyzed"
                value={GENETIC_PROFILE.totalVariants.toLocaleString()}
                sphereColor={sphereColorAt(0)}
              />
              <GradientSphereMetricCard label="Actionable risks" value={actionableRisks} sphereColor={sphereColorAt(1)} />
              <GradientSphereMetricCard label="Elevated" value={elevatedRisks} sphereColor={sphereColorAt(2)} />
              <GradientSphereMetricCard label="Moderate" value={moderateRisks} sphereColor={sphereColorAt(3)} />
            </div>
          </div>

          <SurfaceRow as="aside" className="genetics-profile-panel">
            <Eyebrow variant="section" tone="subtle">Profile details</Eyebrow>
            <dl className="mt-3 space-y-2">
              <div>
                <Eyebrow as="dt" variant="mini" tone="subtle">Provider</Eyebrow>
                <StrongText as="dd" className="mt-1">{GENETIC_PROFILE.provider}</StrongText>
              </div>
              <div>
                <Eyebrow as="dt" variant="mini" tone="subtle">Date processed</Eyebrow>
                <StrongText as="dd" className="mt-1">{GENETIC_PROFILE.dateProcessed}</StrongText>
              </div>
              <div>
                <Eyebrow as="dt" variant="mini" tone="subtle">Actionable variants</Eyebrow>
                <StrongText as="dd" className="mt-1">{GENETIC_PROFILE.actionable}</StrongText>
              </div>
            </dl>
          </SurfaceRow>
        </div>
      </SurfaceCard>

      <SurfaceCard as="article">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <Subheading variant="dashboard">Genetic risk stream</Subheading>
          <Badge variant="zinc">{GENETIC_RISKS.length} entries</Badge>
        </div>

        <div className="genetics-risk-stream mt-4">
          {GENETIC_RISKS.map((risk) => (
            <div
              key={risk.id}
              className="genetics-risk-item"
            >
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <div className="flex flex-wrap items-center gap-2">
                    <StrongText>{risk.variant}</StrongText>
                    <Badge variant="zinc">{risk.gene}</Badge>
                    <Badge variant="zinc">{risk.category}</Badge>
                  </div>
                  <p className={`mt-2 text-sm/6 ${TEXT_SECONDARY}`}>{risk.description}</p>
                </div>
                <Badge variant="zinc">
                  {risk.risk.charAt(0).toUpperCase() + risk.risk.slice(1)}
                </Badge>
              </div>
              {risk.actionable && risk.recommendation && (
                <p className={`mt-2 text-sm/6 italic ${TEXT_SUBTLE}`}>{risk.recommendation}</p>
              )}
            </div>
          ))}
        </div>
      </SurfaceCard>

      <SurfaceCard as="article">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <Subheading variant="dashboard">Pharmacogenomics</Subheading>
          <Badge variant="zinc">{PHARMACOGENOMICS.length} medications</Badge>
        </div>

        <div className="genetics-pharma-grid mt-4">
          {PHARMACOGENOMICS.map((entry) => (
            <SurfaceRow key={entry.drug} className="space-y-2">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="flex flex-wrap items-center gap-2">
                  <StrongText as="span">{entry.drug}</StrongText>
                  <Badge variant="zinc">{entry.gene}</Badge>
                </div>
                <Badge
                  variant="zinc"
                 
                >
                  {entry.status}
                </Badge>
              </div>
              <p className={`text-sm/6 ${TEXT_SECONDARY}`}>{entry.note}</p>
              <div className="flex flex-wrap gap-2">
                <Badge variant="zinc">Medication response</Badge>
              </div>
            </SurfaceRow>
          ))}
        </div>
      </SurfaceCard>
    </div>
  )
}
